import React, { useEffect, useState } from 'react';

const CountDownTimer = ({ expirationDate, customStyles }) => {
  const [timeRemaining, setTimeRemaining] = useState("");

  useEffect(() => {
    const calculateTimeRemaining = () => {
      const now = new Date().getTime(); 
      const endDate = new Date(expirationDate).getTime(); 

      const distance = endDate - now; 

      if (distance < 0) {
        setTimeRemaining("Expired");
        return;
      }

      const totalHours = Math.floor(distance / (1000 * 60 * 60));
      const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((distance % (1000 * 60)) / 1000);

      const formattedTime = `${totalHours.toString().padStart(2, '0')}h : ${minutes.toString().padStart(2, '0')}m : ${seconds.toString().padStart(2, '0')}s`;

      setTimeRemaining(formattedTime);
    };

    const interval = setInterval(calculateTimeRemaining, 1000);

    return () => clearInterval(interval);
  }, [expirationDate]);

  return (
    <div>
      <label style={customStyles ? customStyles : 
        {
          color: 'black', 
          fontSize: '15px',
        }
      }>
        {timeRemaining}
      </label>
    </div>
  );
};

export default CountDownTimer;
